import axios from 'axios';

import {
    GET_MATCHING_ERROR,
    GET_MATCHING_LIST
} from './types';


//list 
export const getRecords = (user_id) => async dispatch => {
    try {
      const res = await axios.get(process.env.REACT_APP_SITE_URL + `/v2/matching/${user_id}`);
  
      dispatch({
        type: GET_MATCHING_LIST, 
        payload: res.data
      });
      return res.data;
    } catch (err) {
      const errors = err.response.data.errors;
      console.log("Error for matching...",err);
      dispatch({
        type: GET_MATCHING_ERROR,
        payload: { msg: errors[0].msg}
      });
      return errors;
    }
  };

